var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaucet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 121,
    viewBox: "0 0 239 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_8705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.89 0.5H90.1229V39.9H145.89V0.5Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1229 0.5H145.89V24.5H150.371C157.541 24.5 163.416 30.3 163.416 37.6V40.5H163.317H75.6833V37.6C75.6833 30.4 81.4592 24.5 88.7288 24.5H90.1229V0.5Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1307 65.4106L116.598 16.7235C116.734 16.4537 117.004 16.4537 117.275 16.5886L117.411 16.7235L147.878 65.2757C158.44 82.269 153.295 104.522 136.233 115.042C119.171 125.561 96.8282 120.437 86.2661 103.443C78.5477 91.44 79.0894 76.6046 86.1307 65.4106Z",
    fill: "url(#paint0_linear_19_8705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.317 40.5H75.6833V37.6C75.6833 30.4 81.4592 24.5 88.7288 24.5H150.371C157.541 24.5 163.416 30.3 163.416 37.6V40.5H163.317Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1307 65.4106L116.598 16.7235C116.734 16.4537 117.004 16.4537 117.275 16.5886L117.411 16.7235L147.878 65.2757C158.44 82.269 153.295 104.522 136.233 115.042C119.171 125.561 96.8282 120.437 86.2661 103.443C78.5477 91.44 79.0894 76.6046 86.1307 65.4106Z",
    fill: "url(#paint1_linear_19_8705)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.331 40.5H101.719L116.598 16.7235C116.734 16.4537 117.004 16.4537 117.275 16.5886L117.411 16.7235L132.331 40.5Z",
    fill: "#0A0B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.01 110.5C131.591 110.5 143.404 98.6316 143.404 84C143.404 69.3684 131.591 57.5 117.01 57.5C102.43 57.5 90.6167 69.3684 90.6167 84C90.6167 98.6316 102.43 110.5 117.01 110.5Z",
    fill: "#FFD200",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.508 71.5V98.5",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 84.5H103.567",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.471 75.5L108.546 94.5",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.471 94.5L108.546 75.5",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9333 101.5C11.5517 101.5 7.96667 97.9 7.96667 93.5C7.96667 97.9 4.38167 101.5 0 101.5C4.38167 101.5 7.96667 105.1 7.96667 109.5C7.96667 105.1 11.5517 101.5 15.9333 101.5Z",
    fill: "#00D17F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75 8.5C55.3683 8.5 51.7833 4.9 51.7833 0.5C51.7833 4.9 48.1983 8.5 43.8167 8.5C48.1983 8.5 51.7833 12.1 51.7833 16.5C51.7833 12.1 55.2687 8.5 59.75 8.5Z",
    fill: "#FED208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.279 54.5C167.897 54.5 164.312 50.9 164.312 46.5C164.312 50.9 160.727 54.5 156.346 54.5C160.727 54.5 164.312 58.1 164.312 62.5C164.312 58.1 167.798 54.5 172.279 54.5Z",
    fill: "#00D17F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 112.5C234.618 112.5 231.033 108.9 231.033 104.5C231.033 108.9 227.448 112.5 223.067 112.5C227.448 112.5 231.033 116.1 231.033 120.5C231.033 116.1 234.618 112.5 239 112.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.183 92.5C206.183 92.5 215.1 83.5457 215.1 72.5C215.1 61.4543 206.183 52.5 195.183 52.5C184.184 52.5 175.267 61.4543 175.267 72.5C175.267 83.5457 184.184 92.5 195.183 92.5Z",
    fill: "#00D17F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.9353,
    height: 16.9353,
    transform: "matrix(0.705629 -0.708581 0.705629 0.708581 183.667 72.9351)",
    fill: "#0A0B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8167 92.5C54.8164 92.5 63.7334 83.5457 63.7334 72.5C63.7334 61.4543 54.8164 52.5 43.8167 52.5C32.817 52.5 23.9 61.4543 23.9 72.5C23.9 83.5457 32.817 92.5 43.8167 92.5Z",
    fill: "#5DE2F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3146 80.7282L38.7934 85.5L38.9941 78.0311L31.8667 76.5788L37.5887 72.0145L34.3764 65.3755L41.303 67.2427L44.3146 60.5L47.3262 67.2427L54.2529 65.3755L51.0405 72.0145L56.7625 76.5788L49.6351 78.0311L49.8359 85.5L44.3146 80.7282Z",
    fill: "#0A0B0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_8705",
    x1: 117.01,
    y1: 16.5,
    x2: 117.01,
    y2: 120.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.271921,
    stopColor: "#5CE2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704269,
    stopColor: "#EBCEF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19_8705",
    x1: 117.01,
    y1: 16.5,
    x2: 117.01,
    y2: 120.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.271921,
    stopColor: "#5CE2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704269,
    stopColor: "#EBCEF8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_8705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 239,
    height: 120,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaucet);
export default __webpack_public_path__ + "static/media/Faucet.7a630d8ccca61c491889a6b7f8522315.svg";
export { ForwardRef as ReactComponent };